import React from 'react';

export function SectionHeader({ label, img }) {
  return (
    <div className="flex justify-center">
      <span className="flex items-center bg-black/[.03] rounded-xl py-2 px-5 my-8">
        {img && (
          <div
            style={{
              backgroundImage: `url(https://img.paperform.co/fetch/w_100,h_100,f_jpg/${img})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
            }}
            className="w-10 h-10 rounded-md m-0 mr-2"
          />
        )}
        <span className="capitalize font-sonoma font-light">{label}</span>
      </span>
    </div>
  );
}
